import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-commercial-invoice-print',
  templateUrl: './commercial-invoice-print.component.html',
  styleUrls: ['./commercial-invoice-print.component.css']
})
export class CommercialInvoicePrintComponent implements OnInit {

  model = { 'invoice_no': '', 'count': '0' };

  Success_Msg; Error_Msg; Invoice_No_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<CommercialInvoicePrintComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Invoice_No_Msg').subscribe((res: string) => {
      this.Invoice_No_Msg = res;
    });

  }

  ngOnInit() {
    console.log(this.dialog_data);
  }

  print() {
    let invoice_list = '';
    this.dialog_data.forEach(element => {
      if (invoice_list != '')
        invoice_list += ';';

      invoice_list += element.invoice_no; 
    });

    let form = (document.getElementById('form1') as HTMLFormElement);
    let html_data_field = document.forms[form.id]['html_data'] as HTMLInputElement;

    html_data_field.value = String(invoice_list);
    form.action = this.applicationConstants.generateComInvoice + "?no=" + this.model['invoice_no'] + "&count=" + this.model['count'] + "&invoice_list";
    form.submit();

    this.dialogRef.close(this.dialog_data);
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}
